module.exports = __webpack_public_path__ + "img/ph.b10798a5.svg";